const urlToAbsolute = (url, domain = "") => {
  // 链接或域名为空，或者已经有域名，直接返回url
  if (!url || !domain || /^http/.test(url)) {
    return url;
  }
  return domain + url;
}


module.exports = {
  urlToAbsolute
}
